"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.useStoreState = exports.useStoreDispatch = exports.useStoreActions = exports.storeModel = void 0;
const easy_peasy_1 = require("easy-peasy");
const stepsDisplayed_1 = require("./actions/stepsDisplayed");
const chatbotAnswers_1 = require("./actions/chatbotAnswers");
const chatbot_1 = require("./actions/chatbot");
exports.storeModel = {
    chatbot: {
        value: undefined,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setQuestionVariableValue: (0, easy_peasy_1.action)(chatbot_1.setQuestionVariableValue),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setComputationVariableValue: (0, easy_peasy_1.action)(chatbot_1.setComputationVariableValue),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setHttpVariableValue: (0, easy_peasy_1.action)(chatbot_1.setHttpVariableValue),
        setChatbot: (0, easy_peasy_1.action)((state, payload) => {
            state.value = payload;
        }),
    },
    stepsDisplayed: {
        value: [],
        addStep: (0, easy_peasy_1.action)(stepsDisplayed_1.addStep),
        removeStep: (0, easy_peasy_1.action)(stepsDisplayed_1.removeStep),
        setStepsDisplayed: (0, easy_peasy_1.action)((state, payload) => {
            state.value = payload;
        }),
    },
    chatbotAnswers: {
        value: [],
        addAnswer: (0, easy_peasy_1.action)(chatbotAnswers_1.addAnswer),
        removeLastAnswer: (0, easy_peasy_1.action)(chatbotAnswers_1.removeLastAnswer),
        setAnswers: (0, easy_peasy_1.action)((state, payload) => {
            state.value = payload;
        }),
    },
};
const typedHooks = (0, easy_peasy_1.createTypedHooks)();
exports.useStoreActions = typedHooks.useStoreActions;
exports.useStoreDispatch = typedHooks.useStoreDispatch;
exports.useStoreState = typedHooks.useStoreState;
exports.store = (0, easy_peasy_1.createStore)((0, easy_peasy_1.persist)(exports.storeModel, {
    allow: ["chatbot", "chatbotAnswers"],
    storage: "localStorage",
}));
//# sourceMappingURL=index.js.map